import { FormFieldTypes } from "../../../../../../../data/formFieldType";


const initialState = {
  lClientKey: null,
  lDepartmentKey: null,
  dtEffectiveDate: "",
  dtEndDate: ""
}

export const addAffiliatesConfig = {
  name: "Add Affiliate",
  initialState: initialState,
  section: [
    {
      sectionId: "AffiliateSection",
      title: "Affiliate Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "lClientKey",
          label: "Client : ",
          Field_Name: "Client",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lClientKey",
          fieldSetting: {
            isEnableOnChange: true,
            placeholder: "Client",
            allowSpace: true,
            option: []
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
        {
          id: "lDepartmentKey",
          label: "Department : ",
          Field_Name: "Department",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lDepartmentKey",
          fieldSetting: {
            isEnableOnChange: true,
            placeholder: "Department",
            allowSpace: true,
            option: []
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
        {
          id: "dtEffectiveDate",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtEffectiveDate",
          fieldSetting: {
            placeholder: "Effective Date",
            subTitle: " ",
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
        },

        {
          id: "dtEndDate",
          label: "End Date :",
          Field_Name: "End Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtEndDate",
          fieldSetting: {
            placeholder: "End Date",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
        },
      ],
    },
  ],
};
